import { BasemapOptionEntity } from '@gishub/domain';
import { BasemapDecorator } from './basemap-decorator';
import { IBasemapSourceStrategyConfig } from '../strategies/i-basemap-source-strategy-config';

export class WithAttributionDecorator extends BasemapDecorator {
  private readonly extraText: string;

  constructor(strategy: BasemapDecorator | IBasemapSourceStrategyConfig, extraText?: string) {
    super(strategy as any);
    this.extraText = extraText ?? '';
  }

  override createConfig(option: BasemapOptionEntity): IBasemapSourceStrategyConfig {
    const config = this.strategy.createConfig(option);
    if (this.extraText) {
      config.attribution = [option.attribution, this.extraText].filter(Boolean).join(' · ');
    }
    return config;
  }
}
